import { SubProductTypeEnum } from '../types/types';

/**
 * Format product type based on SubProductType.
 */
export function formatProductType(subProductType: unknown): string {
  if (typeof subProductType !== 'string') {
    return String(subProductType ?? '');
  }
  switch (subProductType) {
    case SubProductTypeEnum.OTCVanillaOption:
      return 'Vanilla Option';
    case SubProductTypeEnum.OTCFloatingRateLoan:
      return 'Floating Rate Loan';
    case SubProductTypeEnum.OTCFixedRateLoan:
      return 'Fixed Rate Loan';
    case SubProductTypeEnum.OTCForward:
      return 'Forward';
    case SubProductTypeEnum.OTCRepo:
      return 'Repo';
    default:
      return subProductType;
  }
}
